import React from 'react'

import CommonHeader from '@Components/atoms/CommonHeader'
import CommonLayout from '@Components/atoms/CommonLayout'
import SettingList from '@Components/atoms/SettingList'

const MyhouseMyPage = () => {
  return (
    <>
      <CommonHeader title="설정" prevButton={true} />
      <CommonLayout>
        <SettingList />
      </CommonLayout>
    </>
  )
}

export default MyhouseMyPage
